module.exports = __webpack_public_path__ + "img/shape-plus.9c730c43.svg";